module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('label', [_vm._v("Frequency")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20",
      "step": "0.5"
    },
    domProps: {
      "value": _vm.effectConfig.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'frequency', 'Tremolo')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.effectConfig.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'frequency', 'Tremolo')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Depth")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.depth
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'depth', 'Tremolo')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Spread")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "600",
      "step": "50"
    },
    domProps: {
      "value": _vm.effectConfig.spread
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'spread', 'Tremolo')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Wet")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.wet
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'wet', 'Tremolo')
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5abb859b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/effects/tremolo.vue
// module id = 280
// module chunks = 1